<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.date"
                :error-messages="validationErrors.date"
                type="date"
                label="Data"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.time"
                :error-messages="validationErrors.time"
                type="time"
                label="Hora"
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-alert dense type="warning" text outlined>
            {{ __("a alteração não enviará SMS", "schedulings") }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-2">
            <v-btn type="submit" color="primary">{{
              __("alterar", "schedulings")
            }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {
  formatCustomDate,
  formatCustomTime,
  formatDateForInput,
  formatTimeForInput,
} from "@/tools/date";
import ValidationErrorsMixin from "@/mixins/ValidationErrorsMixin.vue";
import ToastsMixin from "@/mixins/ToastsMixin.vue";
import { updateFailureToContact } from "@/services/lead_schedules.js";
import i18n from "@/mixins/i18n";

export default {
  mixins: [ToastsMixin, ValidationErrorsMixin, i18n],
  data() {
    return {
      dialog: false,
      attempt: null,
      form: {
        date: "",
        time: "",
      },
    };
  },
  props: {},
  watch: {},
  computed: {
    title() {
      if (!this.attempt) {
        return "";
      }

      return `Atualizar ${this.attempt.order}ª tentativa de contacto`;
    },
  },
  methods: {
    open(attempt) {
      this.setAttempt(attempt);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    reload(leadScheduling) {
      this.$emit("reload", leadScheduling);
    },

    setAttempt(attempt) {
      this.attempt = { ...attempt };
      this.form.date = formatDateForInput(attempt.date);
      this.form.time = formatTimeForInput(attempt.date);
    },

    formatToISO(date) {
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async submit() {
      try {
        await this.handleFailureToContactUpdate();
      } catch (error) {
        this.toastError("Erro ao enviar formulário:", error);
      }
    },

    async handleFailureToContactUpdate() {
      try {
        const response = await updateFailureToContact(this.attempt.id, {
          ...this.form,
        });
        this.$store.dispatch("refreshLead");
        this.toast("Registro Alterado com sucesso");
        this.close();
        this.reload(response);
      } catch (error) {
        if (error.response?.status === 400) {
          this.toastError(error.response?.data?.message);
          return;
        }

        this.toastError(
          "Ocorreu uma falha ao registar a tentativa de contacto"
        );
      }
    },
  },
};
</script>
